"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Filtering_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/sidebar/components/Filtering.vue"));
const Actions_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/sidebar/components/Actions.vue"));
const PreSelectionArea_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/sidebar/components/PreSelectionArea.vue"));
const UIMiniLoader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UIMiniLoader.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
let Library = class Library extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.filOpen = false;
        this.numFilters = 0;
    }
    expand() {
        this.$emit('onexpandlibrary', this.options.expanded);
    }
    onUpdatedFilter(d, n) {
        this.filOpen = d;
        this.numFilters = n;
    }
    onSelect() {
        const list = this.heatmap.librarySamples;
        const samples = list.getNewSelectedSamples();
        list.markDisabled();
        this.heatmap.addSelection(samples);
    }
    onFilter(filters) {
        this.heatmap.filterLibrary(filters);
    }
    onExpandChange() {
        if (this.options.expanded) {
        }
        else {
            this.onCollapse();
        }
    }
    onCollapse() {
        // Remove the filters so it is reset once we open it again
        this.heatmap.filterLibrary([]);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Library.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Library.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('options.expanded')
], Library.prototype, "onExpandChange", null);
Library = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Grid: lucide_vue_next_1.Grid,
            X: lucide_vue_next_1.X,
            Filtering: Filtering_vue_1.default,
            PreSelectionArea: PreSelectionArea_vue_1.default,
            Actions: Actions_vue_1.default,
            UIMiniLoader: UIMiniLoader_vue_1.default
        }
    })
], Library);
exports.default = Library;
